<template>
<div>
  
  <div class="table-responsive-sm mt-1">
  <table class="table table-bordered table-sm my-table">
     <caption>Tabella prezzo per misura</caption>

    <thead class="thead-light sticky-col">
      <tr>
        <th class="text-center">PREZZO</th>        
        <th v-for="(col, index) in cols"
            :key="index"
            class="text-center sticky-col"
            >
          {{ col.size }}
        </th>
      </tr>
    </thead>

    <tbody>

      <tr v-for="(row, rIndex) in items" :key="rIndex">

        <!-- TIPO -->
        <td class="text-nowrap">
          {{ row.tipo }}
        </td>

                        
        <!-- CAMPI PER MISURA -->
        <td v-for="(col, cIndex) in cols" :key="cIndex">
          <input required type="number" min="0.01" step="0.01"
                 class="form-control form-control-sm inputClass sticky-col"
                 v-model="row.prezzi[col.sizeId]"
                 >
        </td>
        
      </tr>

    </tbody>

  </table>

 </div>

    
  <div v-if="false">
      <h5 class="mb-4">Dati JSON:</h5>
      <pre>{{ items }} {{ product }} </pre> 
      
  </div>


</div> 
</template>

<script>

import { mapGetters }       from 'vuex';

export default {
  
  components: {},  
  props: ['product','costPrice','retailPrice'],
  
  data () {
  
    return {
    

     cols          : [],
     items         : [],


    }
  },
 
  computed:
  {
    ...mapGetters(['company']),
  },
  
  watch: {
    costPrice(newValue) {
      
      this.setCostPrice(newValue)
    },
    retailPrice(newValue) {
      
      this.setRetailPrice(newValue)
    }
  },

   directives: 
    {
      

    },
  mounted()
    {
      
    },
  created()
  {
  
   this.createItems()

  },

  methods: 
  {

      setCostPrice(value) {
          // Per ogni colonna dinamica (escludendo la prima)
          this.cols.forEach(col => {
          // Imposta il valore della cella
          this.items[0].prezzi[col.sizeId] = value;
          this.setData()
          
      })
      },
      setRetailPrice(value) {
          // Per ogni colonna dinamica (escludendo la prima)
          this.cols.forEach(col => {
          // Imposta il valore della cella
          this.items[1].prezzi[col.sizeId] = value;
          this.setData()
      })
      },
      setData()
      {
       
        this.$emit('update',this.items)
      },
    

 
    createItems()
      {


        const generaItems = (acquisto,vendita) => {
          
          /*
            const prezziVuoti = Object.fromEntries(
              misure.map(m => [m.sizeId, 0])
            );
          */

            return [
              { tipo: "ACQUISTO €", prezzi : { ...acquisto } },
              { tipo: "VENDITA €",  prezzi : { ...vendita } }
            ];
          
          }




         /* 
        const generaCols  = (misure)  => {
          return [...misure.map(m => m.size)];
        }
         */ 
        const generaCols = (misure) => {
        return misure.map((m) => {
          return {
            size: m.size,
            sizeId: m.sizeId
          };
        });
        };

        /* ARRIVO DA ORDER UPDATE */
        if(this.product.prices)
        {
            const prezziAcquisto = Object.fromEntries(
              this.product.prices.map(m => [m.sizeId, m.costPrice])
            );
            const prezziVendita = Object.fromEntries(
              this.product.prices.map(m => [m.sizeId, m.retailPrice])
            );

            this.cols    = generaCols(this.product.prices)
            this.items   = generaItems(prezziAcquisto,prezziVendita)
            this.setData()
        }
        else
        {
          const prezzi = Object.fromEntries(
              this.product.sizes.map(m => [m.sizeId, 0])
            );
          this.cols    = generaCols(this.product.sizes)
          this.items   = generaItems(prezzi,prezzi)
          
        }

        


      },

      
      
  }
  
}
</script>

<style scoped>

.inputClass{
  font-weight       : bold;
}

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 14px;
}
.pointer{
  cursor: pointer;
}
thead th.sticky-col {
  z-index: 20;
  background: #28a745;
  color: white;
  border-color: white !important;
  border-top: 2px solid #28a745 !important; 
  border-bottom: 2px solid #28a745 !important;
  
  padding-top       : 6px; /* distanza dal bordo superiore */ 
  padding-bottom    : 6px; /* distanza dal bordo inferiore */ 
  padding-left      : 8px; /* opzionale */ 
  padding-right     : 8px; /* opzionale */

}

.my-table,
.my-table th, 
.my-table td
{
  border-color: #28a745 !important;
}
</style>